module.exports = __webpack_public_path__ + "assets/img/Famoustrademark.43297998.png";